import { useMemo } from 'react';
import { select } from 'redux-saga/effects';
import { useAppSelector } from 'store/hooks';
import { selectGlobalUser } from 'features/users/usersSlice';
import { User, UserId } from 'features/users/types';
import { EventUser } from 'services/signaling';

export const resolveEventUserWithEntries = (
  fallbackUser: EventUser | undefined,
  entries: Record<UserId, User>
) => {
  if (!fallbackUser) {
    return undefined;
  }
  return entries[fallbackUser.id] || fallbackUser;
};

export const useResolvedEventUser = (fallbackUser?: EventUser) => {
  const storedUser = useAppSelector((state) =>
    fallbackUser ? selectGlobalUser(state, fallbackUser.id) : undefined
  );
  return useMemo(() => storedUser || fallbackUser, [storedUser, fallbackUser]);
};

export function* resolveEventUserSaga(fallbackUserOrId?: EventUser | UserId) {
  if (!fallbackUserOrId) {
    return undefined;
  }

  const isUserId = typeof fallbackUserOrId === 'string';
  const userId = isUserId ? fallbackUserOrId : fallbackUserOrId.id;

  const storedUser: User | undefined = yield select(selectGlobalUser, userId);

  return storedUser || (isUserId ? undefined : fallbackUserOrId);
}
